import { FC, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Modal} from '../../../components/Modal'

import { ChatMessageGenerationType } from '../../../models';

import { useAuth } from '../../../context/auth'
import {useThemeMode} from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

interface ChatMessageImageModalProps {
  url: string
  show: boolean
  handleClose: () => void
}

const ChatMessageImageModal: FC<ChatMessageImageModalProps> = ({ url, show, handleClose}) => {
  return <Modal 
    show={show} 
    handleClose={handleClose} 
    dialogClassName="modal-lg"
    modalBodyClassName="overflow-y-auto p-0"
  >
    <img src={url} className="img-fluid rounded" />
  </Modal>
}

interface Props {
  isNotImageGeneration: boolean
  isSending: boolean
  generatedImageUrl: string | undefined
  onLoadGeneratedImage?: () => void
  imageReaction?: string | undefined
  handleReaction: (reaction: string, type: string) => void
  downloadFile: (url: string, type: string) => void
}

const ChatMessageImage: FC<Props> = ({isNotImageGeneration, isSending, generatedImageUrl, onLoadGeneratedImage, handleReaction, imageReaction, downloadFile}) => {
  
  const location = useLocation()
  const isSharedChat = location.pathname.includes('/s/')

  const intl = useIntl()

  const {currentUser} = useAuth()

  const currentSettings = currentUser?.settings

  const {mode} = useThemeMode()

  const [imageLoaded, setImageLoaded] = useState<boolean>(false)

  const [showModal, setShowModal] = useState<boolean>(false)

  return <div className={`position-relative w-100 w-md-400px bg-gray-200 rounded ${isNotImageGeneration && 'my-2'}`}>
    {generatedImageUrl ?
      <img
        src={generatedImageUrl}
        className="w-100 rounded ratio ratio-1x1 cursor-pointer"
        onLoad={()=>{
          onLoadGeneratedImage && onLoadGeneratedImage()
          setImageLoaded(true)
        }}
        onClick={() => setShowModal(true)}
      />
    :
    !isSending && 
    <div className="w-100 rounded ratio ratio-1x1">
      <div className="d-flex flex-center ">
        <i className="fa-solid fa-image fs-5"></i>
      </div>
    </div>
    }
    {
      currentSettings?.response_setting?.reaction && generatedImageUrl && imageLoaded && !isSharedChat && (
        <div className="chat-message-image-options position-absolute pt-4 px-3 top-0 w-100">
          <div className="d-flex flex-stack">
            <div>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {intl.formatMessage({
                      id: "chat.message.good_response",
                    })}
                  </Tooltip>
                }
              >
                <span
                  className={`cursor-pointer bg-${mode === 'dark' ? 'secondary bg-opacity-50 bg-hover-opacity-75' : 'dark bg-opacity-25 bg-hover-opacity-50'} px-3 py-2 rounded`}
                  onClick={() => handleReaction("like", ChatMessageGenerationType.IMAGE)}
                >
                  <i className={`fa-solid fa-thumbs-up ${imageReaction === 'like' ? 'text-primary' : 'text-white'} fs-5`}></i>
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {intl.formatMessage({
                      id: "chat.message.bad_response",
                    })}
                  </Tooltip>
                }
              >
                <span
                  className={`cursor-pointer bg-${mode === 'dark' ? 'secondary bg-opacity-50 bg-hover-opacity-75' : 'dark bg-opacity-25 bg-hover-opacity-50'} px-3 py-2 rounded ms-1`}
                  onClick={() => handleReaction("dislike", ChatMessageGenerationType.IMAGE)}
                >
                  <i className={`fa-solid fa-thumbs-down ${imageReaction === 'dislike' ? 'text-danger' : 'text-white'} fs-5`}></i>
                </span>
              </OverlayTrigger>
            </div>
            <div>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {intl.formatMessage({ id: "general.download" })}
                  </Tooltip>
                }
              >
                <span
                  className={`cursor-pointer bg-${mode === 'dark' ? 'secondary bg-opacity-50 bg-hover-opacity-75' : 'dark bg-opacity-25 bg-hover-opacity-50'} px-3 py-2 rounded`}
                  onClick={() => downloadFile(generatedImageUrl, ChatMessageGenerationType.IMAGE)}
                >
                  <i className="fa-solid fa-download text-white fs-5"></i>
                </span>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      )
    }
    {showModal && <ChatMessageImageModal
      url={generatedImageUrl ? generatedImageUrl : ''}
      show={showModal}
      handleClose={() => setShowModal(false)}
    />}
  </div>
}

export default ChatMessageImage